module.exports = __webpack_public_path__ + "img/ecpay_logo.e9d263d6.png";